import { render, staticRenderFns } from "./hi-input-number.vue?vue&type=template&id=248bce68"
import script from "./hi-input-number.vue?vue&type=script&lang=ts"
export * from "./hi-input-number.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports